import styled from "styled-components";
export const MeetingsummaryStyle = styled.div`
  .wrapper {
    background-color: ${({ theme }) => theme.box};

    border-radius: 10px;
    box-shadow: 0px 1px 15px #00000015;
    .head {
      background-color: ${({ theme }) => theme.body};
      padding: 5px 15px;
      border-top-left-radius: 10px;
      border-top-right-radius: 10px;
    }
    .main {
      padding: 15px;
    }
  }
`;
